// ** Icons Import
import {
  Circle,
  Shield,
  Archive,
  UserCheck,
  ShieldOff,
  Tool,
  Codesandbox,
  Trello,
  Upload,
  Clipboard,
  Server,
  Box,
  Database
} from 'react-feather'
import { IS_ADMIN, IS_MENTOR, IS_SALES } from '../../utility/constants'

export default [
  // {
  //   header: 'Settings',
  //   show: [IS_ADMIN]
  // },
  {
    id: 'Process',
    title: 'Process',
    icon: <Box size={20} />,
    show: [IS_ADMIN, IS_MENTOR],
    children: [
      {
        id: 'assigntopic',
        title: 'Employee Board',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/usertopics'
      },
      {
        id: 'assigntask',
        title: 'Employee Task',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/usertasks'
      },
      {
        id: 'usertechnology',
        title: 'Employee Skill Set',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/usersettings/usertechnology'
      },
      {
        id: 'user-project',
        title: 'Project Teams',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/usersettings/user-project'
      },
      {
        id: 'usermentor',
        title: 'Mentor Teams',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/usersettings/usermentor'
      }
      // {
      //   id: 'userrole',
      //   title: 'User Role',
      //   icon: <Circle size={12} />,
      //   show: [IS_ADMIN],
      //   navLink: '/usersettings/userrole'
      // }
    ]
  },
  {
    id: 'master',
    title: 'Masters',
    icon: <Database size={20} />,
    show: [IS_ADMIN, IS_MENTOR, IS_SALES],
    // `group` is the sub-heading the link is listed under in the sidebar
    children: [
      {
        id: 'user',
        title: 'Employee',
        group: 'People',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR, IS_SALES],
        navLink: '/apps/master/user'
      },
      {
        id: 'mentorMaster',
        title: 'Mentor',
        group: 'People',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/mentormaster'
      },
      {
        id: 'topic',
        title: 'Topic',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/master/topic'
      },
      {
        id: 'common-topic',
        title: 'Common Topic',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/master/common-topic'
      },
      {
        id: 'subtopic',
        title: 'Sub Topic',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/master/subtopic'
      },
      {
        id: 'task',
        title: 'Task',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/master/task'
      },
      {
        id: 'technology',
        title: 'Technology',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/master/technology'
      },
      {
        id: 'skills',
        title: 'Skill',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN, IS_MENTOR],
        navLink: '/apps/master/skills'
      },
      {
        id: 'category',
        title: 'Category',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/category'
      },
      {
        id: 'module',
        title: 'Module',
        group: 'Learning',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/module'
      },
      {
        id: 'project',
        title: 'Project',
        group: 'Organisation',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/project'
      },
      {
        id: 'branch',
        title: 'Branch',
        group: 'Organisation',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/branch'
      },
      {
        id: 'reasonMaster',
        title: 'Reason',
        group: 'Organisation',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/reason'
      },
      {
        id: 'designation',
        title: 'Designation',
        group: 'Organisation',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/master/designation'
      }
    ]
  },
  {
    id: 'roles-permissions',
    title: 'Roles & access',
    icon: <Shield size={20} />,
    show: [IS_ADMIN],
    children: [
      {
        id: 'roles',
        title: 'Roles',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/roles'
      },
      {
        id: 'permissions',
        title: 'Permissions',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/permissions'
      },
      {
        id: 'emailConfiguraion',
        title: 'Email Configuration',
        icon: <Circle size={12} />,
        show: [IS_ADMIN],
        navLink: '/apps/email-configurations'
      }
      // {
      //   id: 'reasonMaster',
      //   title: 'Reason Master',
      //   icon: <Circle size={12} />,
      //   show: [IS_ADMIN],
      //   navLink: '/apps/reason-master'
      // }
    ]
  }

  // {
  //   id: 'bulkupload',
  //   title: 'Bulk Upload',
  //   icon: <Upload size={10} />,
  //   show: [IS_ADMIN, IS_MENTOR],
  //   navLink: '/apps/bulkupload'
  // }
  // {
  //   id: 'projectmapping',
  //   title: 'User Projects',
  //   icon: <Trello size={12} />,
  //   show: [IS_ADMIN],
  //   navLink: '/apps/user-project'
  // }
]
